const rankings = [
  { rank: 1, title: '星际穿越2：新纪元', type: '科幻', hot: '98.7万', change: 'up', tag: 'HOT' },
  { rank: 2, title: '疾速追杀5', type: '动作', hot: '92.3万', change: 'up', tag: 'NEW' },
  { rank: 3, title: '夏洛特烦恼2', type: '喜剧', hot: '88.1万', change: 'up', tag: 'HOT' },
  { rank: 4, title: '消失的真相', type: '悬疑', hot: '76.5万', change: 'down', tag: '' },
  { rank: 5, title: '长安十二时辰', type: '古装', hot: '71.2万', change: 'up', tag: '' },
  { rank: 6, title: '海洋奇缘3', type: '动画', hot: '65.8万', change: 'up', tag: 'NEW' },
  { rank: 7, title: '无间道4：暗战', type: '犯罪', hot: '59.4万', change: 'down', tag: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热播排行榜
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          实时更新的热门影片排行，看看大家都在看什么
        </p>

        <div className="bg-background-50 border border-background-200/60 rounded-lg overflow-hidden">
          {rankings.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-5 py-4 ${
                idx < rankings.length - 1 ? 'border-b border-background-200/40' : ''
              } hover:bg-background-100/50 transition-colors cursor-default`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-md flex-shrink-0 font-heading font-bold text-sm ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-500/80 text-background-50'
                    : item.rank === 3
                    ? 'bg-primary-500/60 text-background-50'
                    : 'bg-background-200/60 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground-900 truncate">
                    {item.title}
                  </span>
                  {item.tag && (
                    <span
                      className={`px-1.5 py-0.5 rounded text-[10px] font-bold whitespace-nowrap ${
                        item.tag === 'HOT'
                          ? 'bg-accent-500/15 text-accent-500'
                          : 'bg-primary-500/15 text-primary-500'
                      }`}
                    >
                      {item.tag}
                    </span>
                  )}
                </div>
                <div className="text-xs text-foreground-500 mt-0.5">{item.type}</div>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-fire-line text-accent-500"></i>
                  </span>
                  {item.hot}
                </div>
                <span className="w-4 h-4 flex items-center justify-center">
                  <i
                    className={`text-sm ${
                      item.change === 'up'
                        ? 'ri-arrow-up-line text-primary-500'
                        : 'ri-arrow-down-line text-foreground-400'
                    }`}
                  ></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}